/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added):not(.btn)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
  window.addEventListener("resize", function () {
    accordionItems.forEach(function (item) {
      if (item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    new Plyr(plyr, {
      controls: ["play-large", "play", "progress", "mute", "current-time"],
      hideControls: true,
      invertTime: false,
      tooltips: { controls: false, seek: false }
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - Scroll down to section
  ========================================================================== */
const scrollLinksInit = function () {
  const scrollLinks = document.querySelectorAll(".pagenav__link");

  // adding class haspagenav to body if there is a page nav
  const pagenav = document.querySelector(".pagenav");
  if (pagenav) {
    document.body.classList.add("haspagenav");
  }

  if (!scrollLinks) {
    return;
  }

  scrollLinks.forEach(scrollLink =>
    scrollLink.addEventListener("click", function (e) {
      e.preventDefault();

      let section = scrollLink.getAttribute("href");

      if (!section) {
        return;
      }

      document.querySelector(section).scrollIntoView({
        behavior: "smooth"
      });
    })
  );
};
scrollLinksInit();

/*  ==========================================================================
	GENERAL - Facility Locations
	========================================================================== */

const facilityLocations = document.querySelectorAll(".module--facility-locations");

const facilityLocationsInit = function () {
  if (facilityLocations.length <= 0) {
    return;
  }

  facilityLocations.forEach(module => {
    const options = module.querySelectorAll(".facility-locations__location button");
    const maps = module.querySelector(".facility-locations__maps");

    options.forEach(option => {
      option.addEventListener("click", function () {
        let activeIndex = option.dataset.id;

        let currentActiveOption = module.querySelector(".facility-locations__location button.active");
        currentActiveOption.classList.remove("active");

        option.classList.add("active");

        // removing active from the current active item unless it has the same index
        let currentMapItem = module.querySelector(".facility-locations__map.active");

        if (currentMapItem && currentMapItem.dataset.id !== activeIndex) {
          // currentMediaItem.style.height = null;
          currentMapItem.classList.remove("active");
        }

        let nextactiveMapItem = module.querySelector('.facility-locations__map[data-id="' + activeIndex + '"]');
        if (nextactiveMapItem) {
          nextactiveMapItem.classList.add("active");
        }
      });
    });
  });
};

facilityLocationsInit();

/*  ==========================================================================
    JOBS - Filter + Load More
    ========================================================================== */

const jobsFiltersInit = function () {
  const filterButtons = document.querySelectorAll(".jobs__filter");
  const jobRows = document.querySelectorAll(".job__row[data-index]");
  const loadMoreBtn = document.getElementById("load_more_jobs");

  if (!jobRows || jobRows.length <= 0) {
    return;
  }

  const batchSize = 12;
  let currentFilter = "all";
  let currentIndex = batchSize;

  const applyFilter = function (filter) {
    currentFilter = filter;
    currentIndex = batchSize;

    let visibleCount = 0;

    jobRows.forEach(function (job) {
      const jobType = job.dataset.type;

      if (filter === "all" || jobType === filter) {
        if (visibleCount < batchSize) {
          job.classList.remove("hidden");
        } else {
          job.classList.add("hidden");
        }
        visibleCount++;
      } else {
        job.classList.add("hidden");
      }
    });

    // toggle load more visibility
    if (visibleCount > batchSize) {
      loadMoreBtn.style.display = "block";
    } else {
      loadMoreBtn.style.display = "none";
    }
  };

  // filter click
  filterButtons.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      filterButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      applyFilter(btn.dataset.filter);
    });
  });

  // load more
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function (e) {
      e.preventDefault();

      let visibleCount = 0;

      jobRows.forEach(function (job) {
        const jobType = job.dataset.type;

        if (currentFilter === "all" || jobType === currentFilter) {
          visibleCount++;

          if (visibleCount > currentIndex && visibleCount <= currentIndex + batchSize) {
            job.classList.remove("hidden");
          }
        }
      });

      currentIndex += batchSize;

      // hide button when finished
      if (visibleCount <= currentIndex) {
        loadMoreBtn.style.display = "none";
      }
    });
  }

  // default load = ALL
  applyFilter("all");
};

jobsFiltersInit();

/*  ==========================================================================
    Homepage  - Arrow animation trigger
    ========================================================================== */

const homepageInit = function () {
  const arrow = document.querySelector(".pageheader--frontpage .pageheader__arrow");
  if (!arrow) {
    return;
  }

  let arrowInteval = setInterval(() => {
    arrow.classList.toggle("hover");
  }, 3000);
};

homepageInit();

/*  ==========================================================================
    Pagenav  - Progress Bar 
    ========================================================================== */

const scrollProgress = document.querySelector(".scrollprogress");

const setProgress = function () {
  let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  let scrolled = (winScroll / height) * 100;

  scrollProgress.style.width = scrolled + "%";
};

const scrollProgressInit = function () {
  if (!scrollProgress) {
    return;
  }

  window.addEventListener("scroll", function () {
    setProgress();
  });
};

scrollProgressInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.innerHTML; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.innerHTML = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    AJAX - Filtering 
    ========================================================================== */

/* filterUpdateURL: Updates the url with the selected values */

const filterUpdateURL = function (filterData) {
  let url_params = "";

  const keys = Object.keys(filterData);

  if (filterData) {
    keys.forEach(key => {
      if (filterData[key] !== "") {
        url_params = "?filter_" + key + "=" + filterData[key];
      }
    });
  }

  // Pagination paramters
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  if (currentPageNum && url_params === "") {
    if (url_params === "") {
      url_params = url_params + "?";
      url_params = url_params + "pagenum=" + currentPageNum;
    }
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = currentPageUrl + url_params;
  if (newUrl !== window.location.href) {
    window.history.pushState({ path: newUrl }, "", newUrl);
  }

  currentPageUrl = newUrl;
};

/* filterGetData: Gets the filtering data */

const filterGetData = function () {
  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOption = document.querySelector('input[type="checkbox"][name=' + el.name + "]:checked");
    if (checkedOption && checkedOption.value !== "") {
      filter_data[el.name] = checkedOption.value;

      // Adding the selected option to the selector
      if (document.querySelector(".filter__selected") && checkedOption.parentNode) {
        document.querySelector(".filter__selected").innerHTML =
          checkedOption.parentNode.getElementsByTagName("label")[0].innerHTML;
      }
    }
  });

  // if there is no filters selected set the filter selector to default
  if (Object.keys(filter_data).length === 0) {
    if (document.querySelector(".filter__selected")) {
      const filterall = document.getElementById("filterall");
      document.querySelector(".filter__selected").innerHTML =
        filterall.parentNode.getElementsByTagName("label")[0].innerHTML;
    }
  }

  return filter_data;
};

/* filterGetPosts: Calls ajax with the filtering data and returns the matching posts */

const filterGetPosts = function () {
  let filterData = filterGetData();

  if (Object.keys(filterData).length === 0) {
    return;
  }
  filterUpdateURL(filterData);

  // Currently turned off
  // // Scroll to filtering system
  // if (document.querySelector(".filter-pin")) {
  //   document.querySelector(".filter-pin").scrollIntoView({ behavior: "smooth"});
  // }

  // Start filtering
  document.querySelector(".loadmore-container").classList.add("runningfilter");

  // Trigger ajax
  let data = {
    action: "filter",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
    filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
    filter_data: filterData
  };

  $.ajax({
    url: php_variables.ajax_url,
    data: data, // form data
    dataType: "json", // this data type allows us to receive objects from the server
    type: "POST",
    success: function (data) {
      // when filter applied:
      // set the current page to 1
      php_variables.current_page = 1;

      // set the new query parameters
      php_variables.posts = data.posts;

      // set the new max page parameter
      php_variables.max_page = data.max_page;

      // hide load more button, if there are not enough posts for the second page

      const pagingLoadmore = document.querySelector(".paging__loadmore");
      if (pagingLoadmore) {
        if (data.max_page < 2) {
          pagingLoadmore.style.display = "none";
        } else {
          pagingLoadmore.style.display = "block";
        }
      }

      // insert the posts to the container
      const loadmoreContainer = document.querySelector(".loadmore-container");
      if (loadmoreContainer) {
        loadmoreContainer.innerHTML = data.content;
        // Finish filtering
        loadmoreContainer.classList.remove("runningfilter");
      }
      // Update the number of posts
      const filterCounter = document.querySelector(".filtercounter");
      if (filterCounter) {
        filterCounter.innerHTML = "(" + data.found_posts + ")";
      }

      // Scroll to filtering system
      // if (document.querySelector(".filter__pin")) {
      //   document.querySelector(".filter__pin").scrollIntoView({ behavior: "smooth" });
      // }

      //Refreshing animations effects
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);

      lazyLoadInstance.update();
    },
    error: function (data) {}
  });
};

const filterForm = document.querySelector(".filter__form");

/* filterInit: Function initialising the filter */

const filterInit = function () {
  if (!filterForm) {
    return;
  }

  filterGetPosts();

  // Adding Event Listeners
  const filterTrigger = document.querySelector(".filter__trigger");
  filterTrigger.addEventListener("click", function () {
    filterTrigger.parentNode.classList.toggle("open");
  });

  const filterOptions = document.querySelectorAll(".filter__option input");
  filterOptions.forEach(input => {
    if (input.type === "checkbox") {
      input.addEventListener("change", function () {
        let formData = {};

        if (input.type === "checkbox") {
          // Unchecking all other options
          filterOptions.forEach(el => {
            if (el !== this) {
              el.checked = false;
            }
          });
        }

        filterTrigger.parentNode.classList.remove("open");

        filterGetPosts();
      });
    }
  });

  filterForm.addEventListener("submit", function (e) {
    // Stop the form from submitting
    e.preventDefault();
    filterGetPosts();
  });
};

filterInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const logosMarquees = document.querySelectorAll(".module__marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const logosMarqueeinit = function () {
  if (logosMarquees.length <= 0) {
    return;
  }

  logosMarquees.forEach(elem => {
    window.addEventListener("resize", function () {
      marquee__resize(elem);
    });

    // Repeating Logos and Text to make sure it fills the width of the view port
    const viewportWidth = window.innerWidth;
    const minWidth = (viewportWidth * 1) / 2;

    const tiles = elem.querySelectorAll(".marquee__tile");
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;

    // Wrapping the tiles
    elem.innerHTML = "<div class='" + innerClass + "'>" + elem.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = elem.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = elem.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    elem.appendChild(repeatingTextClone);
    elem.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    // const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    // marquee_lazyimgs.forEach(img => {
    //   LazyLoad.load(img);
    //   console.log(img);
    // });

    // Setup animation times
    marquee__resize(elem);

    // Once everything is set up, add "loaded" class
    elem.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", logosMarqueeinit);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;
    const animation = elem.dataset.animation ? true : false;

    const activeItem = elem.dataset.activeitem ? true : false;

    var owlCarousel = $(elem)
      .owlCarousel({
        autoplay: autoplay,
        autoplayTimeout: autoplayTimeout,
        loop: loop,
        nav: nav,
        dots: dots,
        animateIn: animation ? "fadeIn" : false,
        items: 1,
        navText: ["<i class='fa-light fa-arrow-left'></i>", "<i class='fa-light fa-arrow-right'></i>"],
        responsive: responsiveArray,
        startPosition: slides.length,
        autoHeight: autoHeight,
        onInitialized: function (event) {
          lazyLoadInstance.update();
          Waypoint.refreshAll();

          // Used in the Campus Status carousel to show the current status
          const owlInstance = event.relatedTarget;

          if (activeItem) {
            let $current = $(event.target).find(".step--current");
            if ($current.length) {
              let index = $current.closest(".owl-item").index();
              owlInstance.to(index, 0);
            }
          }
        }
      })
      .on("changed.owl.carousel", function (event) {
        let indexMenu = elem.parentNode.querySelector(".owlindex__current");
        if (indexMenu) {
          let currentIndex = event.item.index + 1;

          currentIndex = currentIndex < 10 ? "0" + currentIndex : currentIndex;
          indexMenu.textContent = currentIndex;
        }
      });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
    Tabbed Content Carousel
    ========================================================================== */

const tabbedCarousels = document.querySelectorAll(".module--buildings");

const tabbedCarouselInit = function (tabbedCarousels) {
  if (tabbedCarousels.length <= 0) {
    return;
  }

  tabbedCarousels.forEach(elem => {
    const elemOwl = elem.querySelector(".owl-carousel");

    const options = elem.querySelectorAll(".buildings__option");
    options.forEach(option => {
      option.addEventListener("click", function () {
        let id = option.dataset.id;
        const options = elem.querySelector(".buildings__option.active").classList.remove("active");
        option.classList.add("active");
        owlCarousel.data("owl.carousel").to(id, 100, true);
      });
    });

    const slides = elemOwl.querySelectorAll(".item");
    if (!slides) {
      return;
    }

    var owlCarousel = $(elemOwl)
      .owlCarousel({
        items: 1,
        loop: false,
        nav: false,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        margin: 0,
        dots: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        onInitialized: function () {
          lazyLoadInstance.update();
          Waypoint.refreshAll();
        },
        onTranslated: function (event) {},
        onTranslate: function () {
          // refreshing lazyload to target the clone images
          lazyLoadInstance.update();
        }
      })
      .on("changed.owl.carousel", tabbedSyncPositions);

    function tabbedSyncPositions(event) {
      let activiElem = elemOwl.querySelectorAll(".owl-item")[event.item.index];

      if (activiElem.querySelector(".item")) {
        let activiElemID = activiElem.querySelector(".item").dataset.id;
        activiElemID = activiElemID.replace("item-", "");
        if (activiElemID) {
          // Removing active class from the active item
          elem.querySelector(".buildings__option.active").classList.remove("active");
          let nextactive = elem.querySelector('.buildings__option[data-id="' + activiElemID + '"]');
          if (nextactive) {
            nextactive.classList.add("active");
          }
        }
      }
    }
  });
};

tabbedCarouselInit(tabbedCarousels);

/*  ==========================================================================
    Feature Content Carousel
    ========================================================================== */

const featureCarousels = document.querySelectorAll(".featured__carousel");

const featureCarouselInit = function (featureCarousels) {
  if (featureCarousels.length <= 0) {
    return;
  }

  featureCarousels.forEach(module => {
    const elemOwl = module.querySelector(".owl-carousel");
    const elemNav = module.querySelector(".carousel__nav");

    const slides = elemOwl.querySelectorAll(".facility");
    if (!slides) {
      return;
    }

    let featureOwlCarousel = $(elemOwl)
      .owlCarousel({
        items: 1,
        margin: 0,
        autoplay: true,
        autoplayTimeout: 5000,
        loop: false,
        rewind: true,
        dots: false,
        nav: false,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        navText: ["<i class='fa-light fa-arrow-left'></i>", "<i class='fa-light fa-arrow-right'></i>"],
        onInitialized: function () {
          lazyLoadInstance.update();
          Waypoint.refreshAll();

          elemNav.querySelector("button.option[data-index='0']").classList.add("active");
          startProgressBar(elemNav.querySelector(".active"));
        },
        onTranslate: function (event) {
          // refreshing lazyload to target the clone images
          lazyLoadInstance.update();
        }
      })
      .on("changed.owl.carousel", function (event) {
        resetProgressBar(elemNav.querySelector(".active"));
        elemNav.querySelector(".active").classList.remove("active");

        elemNav.querySelector("button.option[data-index='" + event.item.index + "']").classList.add("active");

        startProgressBar(elemNav.querySelector(".active"));
      })
      .on("changed.owl.carousel", function () {
        featureOwlCarousel.trigger("stop.owl.autoplay"); // stop first
        featureOwlCarousel.trigger("play.owl.autoplay", [5000]); // restart with timeout
      });

    // Event Listeners
    elemNav.querySelectorAll("button.option").forEach(btn => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var number = btn.dataset.index;
        featureOwlCarousel.data("owl.carousel").to(number, 300, true);
      });
    });
  });
};

const startProgressBar = function (el) {
  // apply keyframe animation
  const itemProgress = el.querySelector(".progress");
  if (!itemProgress) {
    return;
  }

  itemProgress.style.width = "100%";
  itemProgress.style.transition = "width " + 5000 + "ms linear";
};

const resetProgressBar = function (el) {
  const itemProgress = el.querySelector(".progress");
  if (!itemProgress) {
    return;
  }

  itemProgress.style.width = 0;
  itemProgress.style.transition = "width 0s linear";
};

featureCarouselInit(featureCarousels);

/*  ==========================================================================
	GENERAL - Feature Person Carousel
	========================================================================== */

const personCarousels = document.querySelectorAll(".module--featured-people--carousel");

const personCarouselInit = function () {
  if (personCarousels.length <= 0) {
    return;
  }

  personCarousels.forEach(module => {
    const nav = module.querySelector(".featured-people__nav");
    const options = nav.querySelectorAll(".featured-people__option");
    const bioswrapper = module.querySelector(".featured-people__bios");

    options.forEach(option => {
      if (option.classList.contains("active")) {
        let activePersonBio = module.querySelectorAll(".featured-people__bio.active");
        activePersonBio.forEach(elem => {
          let activePersonBioHeight = elem.querySelector(".inner") ? elem.querySelector(".inner").scrollHeight : 0;
          elem.style.maxHeight = activePersonBioHeight + "px";
          bioswrapper.style.height = activePersonBioHeight + "px";
        });
      }

      window.addEventListener("resize", function () {
        if (option.classList.contains("active")) {
          let activePersonBio = module.querySelectorAll(".featured-people__bio.active");
          activePersonBio.forEach(elem => {
            let activePersonBioHeight = elem.querySelector(".inner") ? elem.querySelector(".inner").scrollHeight : 0;
            elem.style.maxHeight = activePersonBioHeight + "px";
            bioswrapper.style.height = activePersonBioHeight + "px";
          });
        }
      });

      option.addEventListener("click", function () {
        let activeIndex = option.dataset.id;
        let currentActiveOption = nav.querySelector(".featured-people__option.active");

        currentActiveOption.classList.remove("active");

        option.classList.add("active");

        let currentPersonBio = module.querySelectorAll(".featured-people__bio.active");

        currentPersonBio.forEach(elem => {
          if (elem && elem.dataset.id !== activeIndex) {
            elem.classList.remove("active");
            elem.style.maxHeight = null;
          }
        });

        let nextactivePersonBio = module.querySelectorAll('.featured-people__bio[data-id="' + activeIndex + '"]');

        nextactivePersonBio.forEach(elem => {
          elem.classList.add("active");
          let nextactivePersonBioHeight = elem.querySelector(".inner") ? elem.querySelector(".inner").scrollHeight : 0;

          elem.style.maxHeight = nextactivePersonBioHeight + "px";
          bioswrapper.style.height = nextactivePersonBioHeight + "px";
        });
      });
    });
  });
};

personCarouselInit();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
      // siteheaderWrap.classList.remove("color-white");
    } else {
      // IT'S OPEN...
      navopen = false;
      sitenav__close();

      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();

      const mobnavTargetSection = e.target.closest(".sitenav__item");

      if (!mobnavTargetSection.classList.contains(overclass)) {
        navopen = false;
        dropdownsection__open(mobnavTargetSection);
      } else {
        sitenav__out();
      }
    });
  });

  const gobackbtn = document.querySelectorAll(".dropdown__goback");
  gobackbtn.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      let mobnavTargetSection = e.target.closest(".dropdownsection");
      if (mobnavTargetSection) {
        mobnavTargetSection = e.target.closest(".dropdownsection").dataset.section;

        const currentMobSection = document.querySelector(
          ".mobnav .sitenav__item[data-dropdownsection='" + mobnavTargetSection + "']"
        );
        currentMobSection.classList.remove("sitenav__item--open");
      }
      navopen = false;
      sitenav__close();
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
    NAVIGATION - siteheader init
    ========================================================================== */

const siteheader = document.querySelector(".siteheader");
const siteheaderWrap = siteheader.querySelector(".siteheader__wrap");

function siteheader__init() {
  // Change siteheader colors on scroll down

  let prevScrollPos = window.scrollY;

  /* Get the header element and it's position */
  let headerBottom = siteheader.offsetTop + siteheader.offsetHeight;

  window.onscroll = function () {
    let currentScrollPos = window.scrollY;

    if (body.classList.contains(mobnavOpenclass)) {
      return;
    }

    if (currentScrollPos > 0) {
      siteheaderWrap.classList.add("scrolled");
    } else {
      siteheaderWrap.classList.remove("scrolled");
    }
  };
}
siteheader__init();

/*  ==========================================================================
    NAVIGATION - sitenav dropdowns
    ========================================================================== */

const sitenav = document.querySelector(".sitenav--center");
const sitenavitems = sitenav.querySelectorAll("li[data-dropdownsection]");
const sitenavdropdown = document.querySelector(".sitenav__dropdown");
const sitenavdropdownsections = document.querySelectorAll(".dropdownsection");

const overclass = "sitenav__item--over";
const navopenbodyclass = "sitenavopen";
const activesectionclass = "dropdownsection--active";

var navopen = false;
var currentli = false;
var dropdownclosetimer = false;
let currentTopLevelItem = false;
let nextTabItem = false;

// Check if isMobile, and only init if desktop or Ipad
if (!isMobile) {
  sitenav__init();
}

function sitenav__init() {
  const isSmallScreen = window.matchMedia("(max-width: 1000px)").matches;

  // Check if is touchscreen and setup dropdown to show on tap as well as hover
  if (isTouchDevice) {
    // IF TOUCHSCREEN (e.g. Ipad users)...
    // Setup dropdown to show on tap
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.addEventListener("click", function (e) {
        e.preventDefault();

        if (!this.classList.contains(overclass)) {
          navopen = false;
          sitenavitem__over(sitenavitem);
        } else {
          sitenav__out();
        }
      });
    });
  } else {
    // IF DESKTOP...
    sitenavitems.forEach((sitenavitem, index) => {
      sitenavitem.addEventListener("mouseover", e => {
        if (!isSmallScreen) {
          sitenavitem__over(sitenavitem);
        }
      });
      sitenavitem.addEventListener("mouseout", e => {
        if (!isSmallScreen) {
          sitenav__out();
        }
      });
    });

    sitenavdropdown.addEventListener("mouseover", e => {
      if (!isSmallScreen) {
        dropdownsection__over();
      }
    });
    sitenavdropdown.addEventListener("mouseout", e => {
      if (!isSmallScreen) {
        sitenav__out();
      }
    });
  }

  window.addEventListener("resize", function () {
    sitenav__out();
  });
} // sitenav__init()

function sitenavitem__over(sitenavitem) {
  // On hover of sitenav item

  dropdownsection__open(sitenavitem);
} // sitenavitem__over()

function dropdownsection__open(target_li) {
  var target_section = sitenavdropdown.querySelector(".dropdownsection--" + target_li.dataset.dropdownsection);
  var dropdown_height = target_section.offsetHeight;

  // Make dropdown show and set classes to say it's open
  sitenavdropdown.style.visibility = "visible";
  sitenavdropdown.style.height = dropdown_height + "px";
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to stop dropdown closing
    window.clearTimeout(dropdownclosetimer);
  }
  // Remove over class from any old clicks
  if (document.querySelector("." + overclass)) {
    document.querySelector("." + overclass).classList.remove(overclass);
  }
  // add over class to current li
  target_li.classList.add(overclass);
  document.querySelector("body").classList.add(navopenbodyclass);
  // siteheaderWrap.classList.remove("color-white");

  if (document.querySelector("." + activesectionclass)) {
    document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
  }
  target_section.classList.add(activesectionclass);
} //dropdownsection__open();

function dropdownsection__over() {
  // On hover of dropdownsection, keep the dropdown open
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to close the dropdown
    window.clearTimeout(dropdownclosetimer);
  }
  document.querySelector("body").classList.add(navopenbodyclass);
} // sitenavitem__over()

function sitenav__out() {
  // On leave sitenav hover
  navopen = false;
  // Start timeout to close sitenav dropdown
  dropdownclosetimer = window.setTimeout(sitenav__close, 450);
} // sitenavitem__over()

function sitenav__close() {
  // when time out ends and nav open is still false, close the

  if (!navopen) {
    // Set height to 0 and remove classes
    if (document.querySelector("." + activesectionclass)) {
      document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
    }

    document.querySelector("body").classList.remove(navopenbodyclass);
    if (document.querySelector("." + overclass)) {
      document.querySelector("." + overclass).classList.remove(overclass);
    }
    sitenavdropdown.style.height = 0;
    // sitenavdropdown.style.visibility = "hidden";
  }
} // sitenav__close

/*  ==========================================================================
	FORM - Trigger after Form Submission
	========================================================================== */

const triggerAfterSubmit = function () {
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    Waypoint.refreshAll();
  });
};

triggerAfterSubmit();
